import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InvoiceAttachmentsView from '../../components/contentView/invoiceAttachmentsView';

const InvoiceAttachments = ({ location, history }) => {
    const { id } = queryString.parse(location.search);
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={() => history.push('/home')}>
                    Tow sheets
                </Button>
                <Typography variant="h6" component="h2">
                    Invoice {id}
                </Typography>
            </Box>
            <InvoiceAttachmentsView />
        </>
    );
};

export default withRouter(InvoiceAttachments);
